<template>
    <div class="lotto-ball">
        <img class="empty-ball" src="/static/img/ball-empty.png" />

        <svg class="number" ref="number" viewBox="0 0 175 175" width="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
            <g style="transform-origin:50% 50%;">
                <text text-anchor="middle" x="50%" y="63%" font-size="40px">{{ number }}</text>
                <line x1="20%" y1="69%" x2="80%" y2="69%" stroke="black" stroke-width="5" ></line>
            </g>
        </svg>

        <!-- <span class="number" ref="number">{{ number }}</span> -->
        <img class="glow" src="/static/img/ball-glow.png" />
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TweenMax, TimelineMax } from '@/vendor';

    const ROLL_NUM = 5;

    export default {
        props: {
            'number': {
                type: Number,
                default: 42
            }
        },

        data()
        {
            return {
                size: window.innerHeight * 0.1694,
                rollAnim: null,
                distance: 2,
                timeElapsed: 1
            };
        },

        methods: {
            animIn()
            {
                TweenMax.set( this.$refs.number, { transformOrigin: '50% 50%' });

                this.rollAnim = new TimelineMax({ paused: true, delay: 0.3 });

                this.rollAnim.from( this.$refs.number, this.timeElapsed, { rotation: 360 * ROLL_NUM, ease: Linear.easeNone }, 0 );
                this.rollAnim.from( this.$el, this.timeElapsed, { x: '+=' + ( ROLL_NUM * Math.PI * this.size ) + 'vh', ease: Linear.easeNone }, 0 );

                return this.rollAnim;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/components/Ball.vue